<template>
  <ul class="clearfix">
    <li v-for="(book, index) in booklist" class="fl" :key="index">
      <template v-if="book.book">
        <dl class="main-dl clearfix">
          <dt class="fl">
            <router-Link :to="'/bookdetail/' + book.book.id"
              ><img
                v-lazy="imgURL + book.book.iconUrl"
                width="120"
                height="168"
                :alt="book.book.name"
              />
            </router-Link>
          </dt>
          <dd class="main-dd fr">
            <div>
              <router-Link :to="'/bookdetail/' + book.book.id" target="_blank">
                <h4 :title="book.book.name">{{ book.book.name }}</h4>
              </router-Link>
              <a href="#" class="author" v-if="book.book.author != undefined">{{
                book.book.author.name
              }}</a>
              <div class="flex">
                <a href="javaScript" target="_blank">
                  <em>{{ book.book.sort }}</em>
                </a>
                <!-- <span style="margin: 0 3px">|</span>
                <a href="javaScript:" class="name" target="_blank">
                  <em>{{ book.book.words }}字</em>
                </a> -->
                <span style="margin: 0 3px">|</span>
                <em>{{ book.book.finished ? "已完结" : "连载中" }}</em>
              </div>
              <p class="summary">
                {{ book.book.introduce }}
              </p>
            </div>
          </dd>
        </dl>
      </template>
      <template v-else>
        <dl class="main-dl clearfix">
          <dt class="fl">
            <router-Link :to="'/bookdetail/' + book.id"
              ><img
                v-lazy="imgURL + book.iconUrl"
                width="120"
                height="168"
                alt="book.name"
              />
            </router-Link>
          </dt>
          <dd class="main-dd fr">
            <div>
              <router-Link :to="'/bookdetail/' + book.id" target="_blank">
                <h4 :title="book.name">{{ book.name }}</h4>
              </router-Link>
              <a href="#" class="author" v-if="book.author != undefined">{{
                book.author.name
              }}</a>
              <div class="flex">
                <a href="javaScript" target="_blank">
                  <em>{{ book.sort }}</em>
                </a>
                <span style="margin: 0 3px">|</span>
                <a href="javaScript:" class="name" target="_blank">
                  <em>{{ book.words }}字</em>
                </a>
                <span style="margin: 0 3px">|</span>
                <em>{{ book.finished ? "已完结" : "连载中" }}</em>
              </div>
              <p class="summary">
                {{ book.introduce }}
              </p>
            </div>
          </dd>
        </dl>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    booklist: Array
  }
};
</script>

<style></style>
